require('./RAProjectionChartCustomTick.scss');

// @vendor
const PropTypes = require('prop-types');
const React = require('react');

//@utilities
const { formatText } = require('core/i18n').i18n;

class RAProjectionChartCustomTick extends React.Component {
    constructor(props) {
        super(props);

        this.yearsFormatter = this.yearsFormatter.bind(this);
    }

    getYears = () => ({
        2: {
            0: formatText('rentabilityGraph-today'),
            11: formatText('rentabilityGraph-nMonths', ['6']),
            22: formatText('rentabilityGraph-nMonths', ['12']),
            33: formatText('rentabilityGraph-nMonths', ['18']),
            44: formatText('rentabilityGraph-nMonths', ['24']),
        },
        10: {
            0: formatText('rentabilityGraph-today'),
            13: formatText('rentabilityGraph-nYears', ['2']),
            26: formatText('rentabilityGraph-nYears', ['4']),
            39: formatText('rentabilityGraph-nYears', ['6']),
            52: formatText('rentabilityGraph-nYears', ['8']),
            65: formatText('rentabilityGraph-nYears', ['10']),
        },
        25: {
            0: formatText('rentabilityGraph-today'),
            21: formatText('rentabilityGraph-nYears', ['5']),
            42: formatText('rentabilityGraph-nYears', ['10']),
            63: formatText('rentabilityGraph-nYears', ['15']),
            84: formatText('rentabilityGraph-nYears', ['20']),
            105: formatText('rentabilityGraph-nYears', ['25']),
        },
    });

    yearsFormatter(tick) {
        return this.getYears()[this.props.years][tick];
    }

    render() {
        const { payload, x, y, disabled } = this.props;
        let value = !!payload && this.yearsFormatter(payload.value);
        let borderColor = disabled ? '#E3E9E9' : '#546E7A';
        let textColor = disabled ? '#E3E9E9' : '#69788C';
        let content = null;
        if (!!payload) {
            if (payload.value === 0) {
                content = (
                    <g>
                        <rect
                            x={x - 25}
                            y={y - 3}
                            width="50"
                            height="27"
                            rx="15"
                            ry="15"
                            stroke={borderColor}
                            fill="none"
                        />
                        <text
                            x={x}
                            y={y + 16}
                            fill={textColor}
                            textAnchor="middle"
                            className="ra-projection-custom-tick__button"
                        >
                            {value}
                        </text>
                    </g>
                );
            } else if (value) {
                content = (
                    <text
                        x={x}
                        y={y + 16}
                        fill={textColor}
                        textAnchor="middle"
                        className="ra-projection-custom-tick__date"
                    >
                        {value}
                    </text>
                );
            }
        }
        return content;
    }
}

RAProjectionChartCustomTick.propTypes = {
    disabled: PropTypes.bool.isRequired,
    payload: PropTypes.object,
    x: PropTypes.number,
    y: PropTypes.number,
    years: PropTypes.number.isRequired,
};

module.exports = RAProjectionChartCustomTick;
